"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormSuit = void 0;
const Form_1 = require("antd/lib/form/Form");
const react_1 = __importStar(require("react"));
const FormSuiteContext = (0, react_1.createContext)({});
const FormSuiteProvider = ({ children, customForm = undefined }) => {
    const [form] = (0, Form_1.useForm)();
    return react_1.default.createElement(FormSuiteContext.Provider, { value: { form: customForm || form } }, children);
};
const useFormSuit = () => {
    const context = (0, react_1.useContext)(FormSuiteContext);
    const { form } = context;
    return { form };
};
exports.useFormSuit = useFormSuit;
exports.default = FormSuiteProvider;
